import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminGenerate from "@/pages/admin/AdminGenerate";

export const Route = createFileRoute("/admin/generate")({
  component: () => (
    <ProtectedRoute>
      <AdminGenerate />
    </ProtectedRoute>
  ),
});
